<template>
  <c-view>
    <c-page class="s-actionsheet-container">
      <c-navbar title="20201111">
      </c-navbar>
      <c-content>
        <div class="newEleven-box">
          <div class="qrcode-box"></div>
          <span class="title">扫码添加客服 优惠活动抢先体验</span>
          <div class="tag-box">
            <span class="tag-title">全年最低 错过等一年</span>
            <div class="tag-version">
              <div class="version__box1">
                <div class="version__leftbox-left">
                  <span class="version__name">行业终身版<span>原价¥1888</span></span>
                  <span class="version__desc">
                    <span style="display:block;">适用行业：</span>
                    <span style="display:block;">餐饮/美业丽人/服装鞋帽/母婴亲子</span>
                    <span style="display:block;">数码电子/宠物/眼镜</span>
                    <span style="display:block;">赠送移动支付30天0费率</span>
                  </span>
                  <span class="version__tips">
                    <span style="display:block;">11月1日08:00 -10日21:59 支付定金</span>
                    <span style="display:block;">11月11日00:00-23:59 支付尾款</span>
                  </span>
                  <span class="version__dingjin">
                    定金¥100  尾款¥1488 
                  </span>
                </div>
                <div class="version__leftbox-right" @click="buy(263)">
                  <span></span>
                  <span>到手价¥1588</span>
                </div>
              </div>
              <div class="version__box2">
                <div class="version__rightbox-left">
                  <span class="version__name">终身无忧开店套餐<span>原价¥7288</span></span>
                  <span class="version__desc">
                    <span style="display:block;">套餐包含：</span>
                    <span style="display:block;">餐饮/美业丽人/服装鞋帽/母婴亲子</span>
                    <span style="display:block;">数码电子/宠物/眼镜+至尊会员卡+小程序plus终身</span>
                  </span>
                  <span class="version__tips">
                    <span style="display:block;">11月1日08:00 -10日21:59 支付定金</span>
                    <span style="display:block;">11月11日00:00-23:59 支付尾款</span>
                  </span>
                  <span class="version__dingjin">
                    定金¥100  尾款¥5788 
                  </span>
                </div>
                <div class="version__rightbox-right" @click="buy(266)">
                  <span></span>
                  <span>到手价¥5888</span>
                </div>
              </div>
              <div class="version__box3">
                <div class="version__rightbox-left">
                  <span class="version__name">小程序终身<span>原价¥3588</span></span>
                  <span class="version__desc">
                    <span style="display:block;">直播带货 | 会员分销 | 会员在线储值 |  
</span>
                    <span style="display:block;">分享转介绍 | 线上线下一体化 |</span>
                    <span style="display:block;">轻松开网店 </span>
                  </span>
                   <span class="version__free">
                    <img src="../../assets/images/2020-11-11/freeicon.png">
                    <span>行业终身版</span>
                  </span>
                  <span class="version__tips">
                    <span style="display:block;">11月1日08:00 -10日21:59 支付定金</span>
                    <span style="display:block;">11月11日00:00-23:59 支付尾款</span>
                  </span>
                  <span class="version__dingjin">
                    定金¥100  尾款¥3188  
                  </span>
                </div>
                <div class="version__rightbox-right" @click="buy(265)">
                  <span></span>
                  <span>到手价¥3288</span>
                </div>
              </div>
              <div class="version__box4">
                <div class="version__rightbox-left">
                  <span class="version__name">至尊微信会员卡<span>原价¥3588</span></span>
                  <span class="version__desc">
                    <span style="display:block;">无需实体卡 | 扫码即领卡 | 卡样随心换 | </span>
                    <span style="display:block;">推送消息更方便 | 提高复购率</span>
                  </span>
                  <span class="version__free">
                    <img src="../../assets/images/2020-11-11/freeicon.png">
                    <span>行业终身版</span>
                  </span>
                  <span class="version__tips">
                    <span style="display:block;">11月1日08:00 -10日21:59 支付定金</span>
                    <span style="display:block;">11月11日00:00-23:59 支付尾款</span>
                  </span>
                  <span class="version__dingjin">
                    定金¥100  尾款¥3188 
                  </span>
                </div>
                <div class="version__rightbox-right"  @click="buy(264)">
                  <span></span>
                  <span>到手价¥1588</span>
                </div>
              </div>
            </div>
          </div>
          <div class="tag2-box">
            <span class="tag2-box__title">开店利器 付100抵300</span>
            <ul class="version__list">
              <li v-for="(item, index) in list" key="index"  @click="buy(item.id)">
                <span>{{item.title}}</span>  
                <span v-if="">{{item.desc}}</span>
                <span v-if="item.type === 'normal'">{{item.rule}}</span>
                <span v-else>
                  <span style="color:white;display:block;">{{item.rule}}<span style="color:#F8CEA9">{{item.tips}}</span></span>
                  <span style="color:white;display:block;">{{item.rule1}}<span style="color:#F8CEA9">{{item.tip1}}</span></span>
                </span>
                <span>{{item.price}}</span>
              </li>  
            </ul>
          </div>
          <div class="logo-box">

          </div>
        </div>
      </c-content>
      <!-- <c-footer>
        </c-footer> -->
    </c-page>
  </c-view>
</template>

<script>
import { mainWeb } from '@/config/net'
import debounce from 'lodash.debounce'
import Pay from '@/model/pay'
import api from '@/tools/api-tools'
export default {
  name: 'newEleven',
  components: { },
  data () {
    return {
      pay: new Pay(),
      purshedList: [],
      list: [
        {
          title: '至尊版微信会员卡',
          desc: '无需实体卡 | 扫码即领卡 | 卡样随心换 | 推送消息更方便 | 提高复购率',
          rule: '买2年送1年 定金¥100 尾款¥1598',
          price: '到手价¥1698',
          type: 'normal',
          id: 267
        },
        {
          title: '省心开店大礼包',
          desc: '餐饮/美业丽人/服装鞋帽/母婴亲子数码电子/宠物/眼镜+会员卡+小程序plus+2000条短信 送30天零费率',
          rule: '立减709 定金¥100 尾款¥2488',
          price: '到手价¥2588',
          type: 'normal',
          id: 270
        },
        {
          title: '微信小程序',
          desc: '会员在线储值 | 分享转介绍 | 线上线下一体化 | 轻松开网店 ',
          rule: '买2年送1年 定金¥100 尾款¥1598',
          price: '到手价¥1698',
          type: 'normal',
          id: 268
        },
        {
          title: '微信小程序Plus',
          desc: '直播带货 | 会员分销 | 会员在线储值 | 分享转介绍 | 线上线下一体化 | 轻松开网店 ',
          rule: '买2年送1年 定金¥100 尾款¥3598',
          price: '到手价¥3698',
          type: 'normal',
          id: 269
        },
        {
          title: '无忧营销套餐',
          desc: '会员卡+小程序plus 送30天零费率',
          rule: '立减600 定金¥100 尾款¥1988',
          price: '到手价¥2088',
          type: 'normal',
          id: 271
        }
      ]
    }
  },
  mounted () {
    // ,
    //     {
    //       title: '营销短信包',
    //       desc: '',
    //       rule: '1111元/25000条 ',
    //       tips: '0.044元/条',
    //       rule1: '399元/8000条',
    //       tip1: '0.499元/条',
    //       price: '最低0.044元/条',
    //       type: 'special'
    //     }
    this.getStatus()
    api.get(`${mainWeb}/Function/LogAction.ashx?type=weblog&pid=237`) // 预购页埋点
  },
  methods: {
    buy: debounce(async function (id) {
      api.get(`${mainWeb}/Function/LogAction.ashx?type=weblog&pid=238`)
      if (this.purshedList.include(id)) {
        this.$wejs.alert('您已预购此版本！')
        return
      }
      this.pay.saasPay(id, 1)
    }, 220),
    async getStatus () {
      const data = await api.get(`${mainWeb}/OnlineMall/ajax/2020Double11Warmup.ashx`)
      data.forEach(item => {
        this.purshedList.push(item.BusId)
      })
    }
  },
  computed: {
  }
}
</script>

<style lang="scss" scoped>
@import "./index";
</style>



// WEBPACK FOOTER //
// index.vue?1d822c26